import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import media from '../../styles/media.style';
import Video from '../../components/BrightcoveVideo';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Section = styled.section`
  margin: auto;
  max-width: 100%;
  padding: 0 20px;
  width: ${SCREEN_LOCKUP_WIDTH}px;

  ${media.tabletL`
    padding: 45px 45px 60px 45px;
    width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  `};
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.9px;
  margin: 0 auto 50px;
  position: relative;
  text-align: center;

  ${media.tabletL`
    font-size: 18px;
    letter-spacing: 0.7px;
    margin: 0 auto 85px;
  `};

  &::after {
    background-color: black;
    bottom: -25px;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

const VideoSection = ({ title, video }) => (
  <Section>
    {title && <Title>{title}</Title>}
    <Video {...video} />
  </Section>
);

VideoSection.defaultProps = {
  title: undefined,
};

VideoSection.propTypes = {
  title: PropTypes.string,
  video: PropTypes.shape().isRequired,
};

export default VideoSection;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/VideoSection.js